import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const CheckboxComponent = ({ label, field, form, style, ...props }) => {
  const handleChange = (event) => {
    form.setFieldValue(field.name, event.target.checked);
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={field.value} onChange={handleChange} {...props} />}
      label={label}
      style={style}
    />
  );
};

export default CheckboxComponent;
